<template>
  <v-app style="background-color:#F5F5F5">
    <v-app-bar app color="white" elevate-on-scroll dense>
      <v-list-item-icon class="my-auto mr-2">
        <v-img width="32px" height="32px" aspect-ratio="1" :src="logo" />
      </v-list-item-icon>
      <span class="font-weight-bold">Convocation Portal</span>
      <v-spacer />
      <v-btn text small to="/" exact>Home</v-btn>
    </v-app-bar>
    <v-main>
      <v-container>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Defaults from '@/shared/Defaults';
import Links from '@/shared/constants/Links';

export default {
  name: 'ConvocationApp',
  data: () => ({
    logo: Defaults.api + Links.global.logo,
  }),
};
</script>
